//# sourceMappingURL=arrow_right_line.mjs.map
/// <reference types="./arrow_right_line.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function arrow_right_line() {
  return $svg.square(
    24,
    "<path d=\"M13.172 12.1147L8.22198 7.16473L9.63598 5.75073L16 12.1147L9.63598 18.4787L8.22198 17.0647L13.172 12.1147Z\" fill=\"currentColor\"/>",
  );
}
